import React from 'react';
import './SessionDisplaced.css';

/* Shown on the device that lost the account.
 *
 * An account holds one session. When it signs in somewhere else the tables go
 * with it, so this device is no longer playing — and it has to say so plainly
 * rather than simply going quiet, because a silent dead socket looks exactly
 * like a frozen table.
 *
 * Taking the account back is a reload: the same browser reconnects with the
 * same client id and displaces the other device in turn.
 */
export default function SessionDisplaced() {
  return (
    <div className="sd" role="alertdialog" aria-labelledby="sd-title">
      <div className="sd-panel">
        <h2 className="sd-title" id="sd-title">Signed in on another device</h2>
        <p className="sd-body">
          Your account is playing somewhere else. Your seats and chips went with
          it — nothing has been lost, and no hand is being played from here.
        </p>
        <button className="sd-action" onClick={() => window.location.reload()}>
          Play here instead
        </button>
      </div>
    </div>
  );
}
